// extracted by mini-css-extract-plugin
export default {"greenText":"_3c6489c3"};